/** Hint UX minimale per vettore + data carico.
 *
 *  Mar 2026 — source of truth PRIMARIA: `carrier.loading_schedule_config`
 *  (JSONB admin-managed, chiavi MONDAY..FRIDAY con `{enabled, cutoff_weekday,
 *  cutoff_time}`). Fallback legacy: `carrier.preferred_loading_days`
 *  (array 0=Lun..6=Dom) — usato solo se `loading_schedule_config` è vuoto,
 *  per non regredire i vettori non ancora migrati.
 *
 *  MAI vincolante: nessuna validazione, nessun blocco. Solo badge/warning
 *  informativo. La logistica può sempre scegliere una data eccezionale.
 */
const _JS_TO_KEY = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

export function jsDayToMonZero(date) {
  // JS getDay(): 0=Dom, 1=Lun...6=Sab → convert to 0=Lun...6=Dom.
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const jsDay = d.getDay();
  return (jsDay + 6) % 7;
}

function _weekdayKey(dateISO) {
  const d = dateISO instanceof Date ? dateISO : new Date(dateISO);
  if (Number.isNaN(d.getTime())) return null;
  return _JS_TO_KEY[d.getDay()];
}

function _hasAnyEnabled(cfg) {
  if (!cfg || typeof cfg !== "object") return false;
  return Object.values(cfg).some((v) => v && v.enabled);
}

export function carrierPreferredStatus(carrier, dateISO) {
  // Ritorna: "match" | "mismatch" | "none"
  //  - "match":    data coincide con un giorno di carico attivo
  //  - "mismatch": data NON coincide, ma il vettore ha una configurazione
  //  - "none":     nessuna configurazione (né loading_schedule_config né
  //                preferred_loading_days) → non mostrare nulla
  if (!carrier || !dateISO) return "none";
  const cfg = carrier.loading_schedule_config;
  if (_hasAnyEnabled(cfg)) {
    const key = _weekdayKey(dateISO);
    if (!key) return "none";
    return cfg[key] && cfg[key].enabled ? "match" : "mismatch";
  }
  // Legacy fallback (pre-v36 vettori non ancora migrati)
  const pref = carrier.preferred_loading_days;
  if (!Array.isArray(pref) || pref.length === 0) return "none";
  const day = jsDayToMonZero(dateISO);
  if (day === null) return "none";
  return pref.includes(day) ? "match" : "mismatch";
}

// Sorting: quando c'è una data, mostra prima i vettori il cui giorno abituale coincide.
// Vettori senza preferenza restano nella loro posizione naturale (rank 1, tra match e mismatch).
export function sortCarriersByPreferred(carriers, dateISO) {
  if (!dateISO || !Array.isArray(carriers)) return carriers;
  const rank = (c) => {
    const s = carrierPreferredStatus(c, dateISO);
    if (s === "match") return 0;
    if (s === "none") return 1;
    return 2;
  };
  return [...carriers].sort((a, b) => rank(a) - rank(b));
}

export const DAY_LABELS_IT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
